import {RepositoryFactory} from '../factories/RepositoryFactory';
const {version} = require('../../../package.json');

export function logVersion() {
	console.log(`Thrive ${version} ${RepositoryFactory.environment.environmentKind} started`);
}
